let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1nfxc")).then(() => parcelRequire('9zt62'));